import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { AppRouter } from './routers/AppRouter';
import './styles/main.scss';
import { createStore } from './redux/store/initialise';
import { securityService } from './services/security.service';
import { queryClient } from './utils/query-client';
import favIcon from './assets/images/favicon.ico';
const appRoot = document.createElement('div');
appRoot.id = 'root';
document.body.appendChild(appRoot);
const root = ReactDOM.createRoot(appRoot);
const store = createStore();
const authPromise = window.location.href.includes('/login/callback')
    ? securityService.completeUserAuth()
    : securityService.checkUserSession();
authPromise
    .then((auth) => {
    const favIconLink = document.createElement('link');
    favIconLink.rel = 'icon';
    favIconLink.type = 'image/ico';
    favIconLink.href = favIcon;
    document.head.appendChild(favIconLink);
    if (auth.status === 'Authenticated') {
        root.render(React.createElement(QueryClientProvider, { client: queryClient },
            React.createElement(Provider, { store: store },
                React.createElement(AppRouter, { auth: auth }))));
    }
    else {
        return securityService.inititateUserAuth();
    }
})
    .then((loginUrl) => {
    if (loginUrl)
        window.location.href = loginUrl;
})
    .catch((error) => {
    console.log(error);
});
